import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('trip_destination_id')
];

const config: IFormConfig = { 
	title: 'Aggiungi una Destinazione al prodotto',
	fields: formFields 
};

export default config;
